export default __webpack_public_path__ + "static/media/ic_atom_24.b7f8446f.svg";